import { Redirect } from 'expo-router';

/** AdminIndex - redirects to the admin dashboard as the default admin route */
export default function AdminIndex() { return <Redirect href="/admin/dashboard" />; }
